import React, { useContext, useEffect, useState } from 'react';
import ModalFilters, { SeparatorFilter } from '../../../../components/modalfilters';
import { SelectOptions } from '../../../../@types';
import ApiGeral from '../../../../services/ApiGeral';
import { CustumerContext } from '../../../../contexts/custumer';
import moment from 'moment';
import { IFiltros, initialFiltros } from '..';





interface IRelatoriosFiltrosModalProps {
  handleClose: () => void;
  filtros: IFiltros;
  onApply: (filtros: IFiltros) => void;
  opcoesLocal: SelectOptions[];
  opcoesTurno: SelectOptions[];
  opcoesEmpresa: SelectOptions[];
  opcoesSituacao: SelectOptions[];
  dateInit: string;
  dateFin: string;
}


interface IOpcoesFuncionario extends SelectOptions {
  re: string
}

const RelatoriosFiltrosModal: React.FC<IRelatoriosFiltrosModalProps> = ({
  handleClose,
  onApply,
  filtros: filtrosIniciais,
  opcoesEmpresa,
  opcoesLocal,
  opcoesTurno,
  opcoesSituacao,
  dateInit,
  dateFin
}) => {
  const [filtros, setFiltros] = useState<IFiltros>(filtrosIniciais);
  const [opcoesFuncionario, setOpcoesFuncionario] = useState<IOpcoesFuncionario[]>([]);
  const [opcoesAreaSupervisao, setOpcoesAreaSupervisao] = useState<SelectOptions[]>([]);
  const [reFuncionario, setReFuncionario] = useState(filtros.funcionario ?? '');

  const { id_current_custumer } = useContext(CustumerContext)



  useEffect(() => {
    if (filtros.empresaFuncionario) {
      carregarFuncionarios();
      setReFuncionario('');
      update('funcionario', null);
    } else {
      setOpcoesFuncionario([]);
    }
  }, [filtros.empresaFuncionario, filtros.local]);


  useEffect(() => {
    if (filtros.empresaCliente) {
      carregarAreaSupervisao();
    } else {
      setOpcoesAreaSupervisao([]);
    }
  }, [filtros.empresaCliente])





  async function carregarFuncionarios() {
    try {

      const hoje = moment().format('YYYYMMDD');

      const body = {
        empresa: Number(filtros.empresaFuncionario),
        cliente: id_current_custumer,
        local: Number(filtros.local),
        dataInicio: dateInit ? dateInit.replaceAll('-', '') : hoje,
        dataFinal: dateFin ? dateFin.replaceAll('-', '') : hoje
      }


      const response = await ApiGeral.getFuncionariosList(body);

      if (!response.error && response.funcionario) {
        setOpcoesFuncionario(response.funcionario.map(f => ({
          label: f.nome,
          value: f.funcionario,
          re: f.re
        })));
      }
    } catch (error) {
      throw new Error(`getFuncionarios: ${error}`);
    }
  }

  async function carregarAreaSupervisao() {
    try {
      const response = await ApiGeral.getAreaSupervisao(Number(filtros.empresaCliente!));

      if (!response.error && response.areasSupervisao) {
        setOpcoesAreaSupervisao(response.areasSupervisao.map(a => ({
          label: a.descricao,
          value: a.areaSupervisao
        })));
      }
    } catch (error) {
      throw new Error(`getAreaSupervisao: ${error}`);
    }
  }


  function update<K extends keyof IFiltros>(key: K, value: IFiltros[K]) {
    setFiltros(prev => ({ ...prev, [key]: value }));
  }

  function toggleSituacao(value: string) {
    setFiltros(prev => ({
      ...prev,
      situacaoRonda: prev.situacaoRonda.includes(value)
        ? prev.situacaoRonda.filter(s => s !== value)
        : [...prev.situacaoRonda, value]
    }));
  }

  function handleEmpresaClienteChange(value: string | number | null) {
    setFiltros(prev => ({ ...prev, empresaCliente: value, areaSupervisao: null }));
  }

  function handleEmpresaFuncionarioChange(value: string | number | null) {
    setFiltros(prev => ({ ...prev, empresaFuncionario: value, funcionario: null }));
  }

  function handleClean() {
    setFiltros(initialFiltros);
  }

  const filter_container_style = "flex flex-col gap-2 w-full";
  const section_style = "flex flex-col gap-2";
  const input_style = "border-none rounded px-3 py-2 text-sm bg-gray-100"


  return (
    <ModalFilters handleClose={handleClose} applyFilter={() => onApply(filtros)} cleanFilter={handleClean} title="Filtros">
        <div className={section_style}>
        <div className={filter_container_style}>
          <label className="text-xs text-black/50">Empresa cliente</label>
          <select
            className={input_style}
            value={filtros.empresaCliente ?? ''}
            onChange={e => handleEmpresaClienteChange(e.target.value || null)}
          >
            <option value="">Selecione a empresa</option>
            {opcoesEmpresa.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className={filter_container_style}>
          <label className="text-xs text-black/50">Local</label>
          <select
            className={input_style}
            value={filtros.local ?? ''}
            onChange={e => update('local', e.target.value || null)}
          >
            <option value="">Selecione</option>
            {opcoesLocal.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>


        <div className={filter_container_style}>
          <label className="text-xs text-black/50">Área de supervisão</label>
          <select
            disabled={!filtros.empresaCliente}
            className={`${input_style} disabled:bg-gray-100 disabled:text-black/30 disabled:cursor-not-allowed`}
            value={filtros.areaSupervisao ?? ''}
            onChange={e => update('areaSupervisao', e.target.value || null)}
          >
            <option value="">Selecione</option>
            {opcoesAreaSupervisao.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>
      </div>

      
        

      <SeparatorFilter />

      <div>
        <div className="flex flex-col gap-2 w-full">
          <label className="text-xs text-black/50">Situação da ronda</label>
          <div className="flex flex-wrap gap-2">
            {opcoesSituacao.map(s => {
              const active = filtros.situacaoRonda.includes(s.value as string);
              return (
                <button
                  key={s.value}
                  type="button"
                  onClick={() => toggleSituacao(s.value as string)}
                  className={`text-xs px-3 py-1.5 rounded-full border border-solid transition-colors ${
                    active
                      ? 'bg-primary border-blue-600 text-white'
                      : 'bg-white border-gray-300 text-black/60'
                  }`}
                >
                  {s.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <SeparatorFilter />

      <div className={section_style}>
        <div className={filter_container_style}>
          <label className="text-xs text-black/50">Turno</label>
          <select
            className={input_style}
            value={filtros.turno ?? ''}
            onChange={e => update('turno', e.target.value || null)}
          >
            <option value="">Selecione</option>
            {opcoesTurno.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className={filter_container_style}>
          <label className="text-xs text-black/50">Empresa funcionário</label>
          <select
            className={input_style}
            value={filtros.empresaFuncionario ?? ''}
            onChange={e => handleEmpresaFuncionarioChange(e.target.value || null)}
          >
            <option value="">Selecione</option>
            {opcoesEmpresa.map(o => (
              <option key={o.value} value={o.value}>{o.label}</option>
            ))}
          </select>
        </div>

        <div className={filter_container_style}>
          <label className="text-xs text-black/50">Funcionário</label>

          <div className="flex gap-2">
            <input
              type="text"
              inputMode="numeric"
              value={reFuncionario}
              placeholder="RE"
              disabled={!filtros.empresaFuncionario}
              className={`${input_style} w-[70px] disabled:bg-gray-100 disabled:text-black/30 disabled:cursor-not-allowed`}
              onChange={(e) => {
                const valor = e.target.value.trim();
                
                const funcionario = opcoesFuncionario.find(
                  (o) => String(o.re) === valor
                );

                setReFuncionario(funcionario?.re!);

                update('funcionario', funcionario ? funcionario.value : null);
              }}
            />

            <select
              disabled={!filtros.empresaFuncionario}
              className={`${input_style} flex-1 disabled:bg-gray-100 disabled:text-black/30 disabled:cursor-not-allowed`}
              value={filtros.funcionario ?? ''}
              onChange={(e) => {
                const valor = e.target.value.trim();
                
                const funcionario = opcoesFuncionario.find(
                  (o) => String(o.value) === valor
                );
                
                setReFuncionario(funcionario?.re!);

                update('funcionario', e.target.value || null)

              }}
            >
              <option value="">Selecione</option>

              {opcoesFuncionario.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
          </div>
        </div>


        <label className="flex items-center gap-2 text-sm text-black/70">
          <input
            type="checkbox"
            checked={filtros.possuiOcorrencia}
            onChange={e => update('possuiOcorrencia', e.target.checked)}
          />
          Possui ocorrência
        </label>
      </div>
    </ModalFilters>
  )
}

export default RelatoriosFiltrosModal;